<template>
  <div class="externalLink">
    <h3 class="py-title col-w tx-c">{{ systemConfig.BisWebSiteName }}</h3>
    <div class="bg-w py-background ub ub-ae ub-pc">
      <img src="../login/img/style.png" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import store from '@/store/'
import { setToken, setSystem, getSystem } from '@/utils/auth.js'
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr'
import { PublicInterfaceInfoController } from '@/service/PublicInterfaceInfoController/PublicInterfaceInfoController'
import { handleTitle } from '@/utils/dev-helper.js'

export default {
  name: 'externalLink',
  components: {},
  props: {},
  data() {
    return {
      systemConfig: {},
      loginFlag: null,
      publicInterfaceInfoController: new PublicInterfaceInfoController(),
      sysConfigServiceSvr: new SysConfigServiceSvr(),
      code: '',
      userType: '',
    };
  },
  computed: {
    ...mapState(['token', 'reFreshTime']),
  },
  created() {
    this.$store.commit('SET_CODE', this.$route.query.code);
    this.code = this.$route.query.code || this.$route.query.grantCode;
    this.$store.commit('SET_REFRESHTIME', this.reFreshTime + 1);
    localStorage.setItem('code', this.$route.query.code);
    this.handleEnter()
  },
  mounted() {
    this.onOriginMount()
  },
  methods: {
    ...mapMutations(['SET_CODE']),
    getSystemConfig() {
      this.sysConfigServiceSvr
        .getSystemConfig('redirect2SSOURL')
        .then((res) => {
          if (res === null || res === '' || !res.redirect2SSOURL) {
            this.$route.push('wscsdl');
          } else {
            setTimeout(() => {
              window.location.href = res.redirect2SSOURL;
            }, 500);
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },

    /** 首次进入处理 */
    handleEnter() {
      this.loginFlag = this.$route.query.loginFlag || null
      if (this.loginFlag == 1) {
        this.onOriginEnter()
      }else{
        this.publicInterfaceInfoController
        .queryOrgFirstLoginByCode(this.code)
        .then(res => {
          // 首次登录
          if (res.loginFlag) {
            // 进入首次登录页
            this.$router.push('/firstEntry')
          }
          // 非首次登录
          else {
            this.userType = res.userType
            // 作原登录处理
            this.onOriginEnter()
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          })
        })
      }
      
    },

    /** 原本登录处理 */
    onOriginEnter() { 
      //深圳住建登陆接口判断，有type值就走深圳住建认证，没有就走老的维修金判断
      this.loginFlag = this.$route.query.loginFlag || null
        if (this.loginFlag == 1) {
          localStorage.setItem('code', this.$route.query.grantCode);
          this.publicInterfaceInfoController.CheckUserInfoByCodeFromZhzj(this.$route.query.grantCode).then((res) => {
            if (res.Token) {
              setToken(res.Token);
              store.commit('SET_TOKEN', res.Token);
              this.$router.push('/index');
              this.$bus.$emit('getCompanyInfo', res);
            } else {
              if (this.reFreshTime >= 3) {
                // this.$confirm('登录系统失败，请联系客服', '警告', {
                //   distinguishCancelAndClose: true,
                //   confirmButtonText: '确定',
                // })
                this.$confirm('', {
                  message: h('div', null, [
                    h('i', { class: 'el-icon-warning', style: 'color:#f90;font-size:25px;' }),
                    h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, '警告'),
                    h('p', { style: 'margin:10px 0 0 40px;' }, '登录系统失败，请联系客服'),
                    h('p', { style: 'margin:10px 0 0 40px;' }, '客服电话：0755-82794696 0755-82790596')]),
                  distinguishCancelAndClose: true,
                  confirmButtonText: '确定',
                })
                  .then(() => { })
                  .catch(() => { });
              } else {
                this.getSystemConfig();
              }
            }
          }).catch((err) => {
            console.log('智慧住建的认证失败！');
          })
        } else {
          this.publicInterfaceInfoController
            .CheckUserInfoByCode(this.$route.query.code, this.userType)
            .then((res) => {
              if (res.Token) {
                setToken(res.Token);
                store.commit('SET_TOKEN', res.Token);
                this.$router.push('/index');
                this.$bus.$emit('getCompanyInfo', res);
              } else {
                if (this.reFreshTime >= 3) {
                  // this.$confirm('登录系统失败，请联系客服', '警告', {
                  //   distinguishCancelAndClose: true,
                  //   confirmButtonText: '确定',
                  // })
                  this.$confirm('', {
                    message: h('div', null, [
                      h('i', { class: 'el-icon-warning', style: 'color:#f90;font-size:25px;' }),
                      h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, '警告'),
                      h('p', { style: 'margin:10px 0 0 40px;' }, '登录系统失败，请联系客服'),
                      h('p', { style: 'margin:10px 0 0 40px;' }, '客服电话：0755-82794696 0755-82790596')]),
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                  })
                    .then(() => { })
                    .catch(() => { });
                } else {
                  this.getSystemConfig();
                }
              }
            })
            .catch((err) => {
              const h = this.$createElement
              this.$confirm('', {
                message: h('div', null, [
                  h('i', { class: 'el-icon-warning', style: 'color:#f90;font-size:25px;' }),
                  h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, '温馨提示'),
                  h('p', { style: 'margin:10px 0 0 40px;' }, err.Msg),
                  h('p', { style: 'margin:10px 0 0 40px;' }, '客服电话：0755-82794696 0755-82790596')]),
                cancelButtonText: '关闭',
                showConfirmButton: false,
              }).then(() => {
                window.location.href = 'about:blank'
                window.close()
              })
                .catch(() => {

                  window.location.href = 'about:blank'
                  window.close()

                });

            });
        }
    },

    /** 原挂载处理 */
    onOriginMount() {
      if (
        getSystem() === undefined ||
        getSystem() === null ||
        getSystem() === ''
      ) {
        this.sysConfigServiceSvr
          .getSystemConfig('BisWebSiteName')
          .then((res) => {
            this.systemConfig = res;
            handleTitle(this.systemConfig.BisWebSiteName)
            setSystem(res);
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err.Msg,
            });
          });
      } else {
        this.systemConfig = getSystem();
        handleTitle(this.systemConfig.BisWebSiteName)
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.externalLink {
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1965ad, #2ba3de, #1965ad);
  overflow: hidden;
  .py-title {
    margin-top: 10%;
    margin-bottom: 35px;
    font-size: 30px;
    letter-spacing: 6px;
    font-weight: 600;
    border-radius: 4px;
  }
  .py-background {
    width: 720px;
    height: 380px;
    margin: 0 auto;
  }
}
</style>
